import { useParams, useNavigate } from 'react-router-dom';
import '../App.js';
import Tags from './Tags'
import 'bootstrap-icons/font/bootstrap-icons.css';
import React, { useEffect } from 'react';
import axios from '../apis/Axios.js';
import usePost from '../hooks/usePost.js';

function PostOnePage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [title, setTitle] = React.useState(); 
    const [content, setContent] = React.useState();
    const [author, setAuthor] = React.useState();
    const [creationDate, setCreationDate] = React.useState();
    const [comments, setComments] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const { setPost } = usePost();

    useEffect(() => {
        const getPostData = async () => {
            setLoading(true);
            var title;
            var content;
            var author;
            var creationDateTemp;
            var creationDate;
            var comments;

            try { 
                const res = await axios.get('api/Post/' + id);

                title = res.data.title;
                content = res.data.content || '';
                content = content.split('\n').map((str, index) => <p key={index}>{str}</p>);
                author = res.data.author;

                console.log(res.data);  
                console.log(res.data.creationDate);

                creationDateTemp = new Date(res.data.creationDate);
                creationDate = creationDateTemp.toISOString().substring(0, 10);

                // get comments
                comments = res.data.comments || [];

                // setting data
                setTitle(title);
                setContent(content);
                setAuthor(author);
                setCreationDate(creationDate);
                setComments(comments);
                
                // store post-id in the context
                setPost({ id: parseInt(id) });

            } catch (err) {
                console.log('Error loading post:', err);
                console.error('Full error:', err.response || err);
            } finally {
                setLoading(false);
            }
        }
        getPostData();
    }, [id, setPost]);

    const handleReplyClick = (e) => {
        e.preventDefault();
        navigate(`/create-comment/${id}`);
    }

    if (loading) {
        return <div className='post-one-page'><p>Loading post...</p></div>;
    }

    return (
        <div className='post-one-page'>
            <div className='post-one-page-content'>
                <div className='post-one-page-title'>
                    {title}   
                </div>
                <div className='post-one-page-content-text'>
                    {content}
                </div>
                <div className='post-one-page-info'>
                    <span className='post-author'>{author}, </span>
                    <span className='post-date'>{creationDate}</span>
                </div>
                <div className='post-one-page-edit'>
                    <i style={{ display: 'none' }} className='post-one-page-icon bi bi-pencil-square h4 me-2'></i>
                    <i style={{ display: 'none' }} className='post-one-page-icon bi bi-trash-fill h4 me-2'></i>
                    <button 
                        className='btn btn-dark me-2 mt-2' 
                        type='button'
                        onClick={handleReplyClick}
                    >
                        <span className='button-delete-text'>
                            Reply
                        </span>
                    </button>
                </div>
            </div>

            {/* Comments Section */}
            <div className='comments-section mt-5'>
                <div className='comments-count'>
                    Comments ({ comments.length })
                </div>
                {comments.length === 0 ? (
                    <p className='text-muted'>No comments yet.</p>
                ) : (
                    <div className='comments-list'>
                        {comments.map((comment, index) => (
                            <div key={comment.id || index} className='comment-item mb-3'>
                                <div className='card-body'>
                                    <p className='comment-content'>{comment.content}</p>
                                    <div className='comment-info text-muted'>
                                        <small>
                                            <span className='comment-author'>{comment.author}</span>
                                            {' - '}
                                            <span className='comment-date'>
                                                {new Date(comment.creationDate).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric'
                                                })}
                                            </span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
};

export default PostOnePage;